import {
  orgID,
  websiteID,
  traceID,
  sessionID,
  apiDomain,
} from "../../settings";
import { RL_PREVIEW } from "./queryParams";

type LogParams = {
  severity: 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7; // Only allow valid severity levels
};

const traceIDQueryParameter = "tid";
const btTagVersionQueryParameter = "cv";
const sessionIDQueryParameter = "sid";

const extraMeta: Record<string, object | string> = {};

export function setLogMetaKV(key: string, value: object | string): void {
  extraMeta[key] = value;
}

type EventType =
  | "rlink.getSettingsError"
  | "rlink.executionError"
  | "rlink.scaState"
  | "rlink.recoveryStateMismatch"
  | "rlink.settingsMismatch"
  | "rlink.getConsent"
  | "rlink.detectCountry"
  | "rlink.onPageViewError"
  | "rlink.appendKVP"
  | "rlink.restoreServerSideAttribution"
  | "rlink.scaRejected"
  | "rlink.scaResponseTime"
  | "rlink.onRecoverError"
  | "timing.rlinkScriptLoaded"
  | "rlink.storageError"
  | "rlink.impressionTracking"
  | "rlink.invalidateUserDataError"
  | "rlink.setServerSideUserStateError";

/*
severity mapping:
1. "debug" -> 0
2. "info" -> 1
3. "notice" -> 2
4. "warning" -> 3
5. "error" -> 4
6. "critical" -> 5
7. "alert" -> 6
8. "emergency" -> 7
*/
export async function log<T>(
  event: EventType,
  meta: Record<string, object | string | T> = {},
  params: LogParams = { severity: 1 },
) {
  if (RL_PREVIEW) {
    return;
  }

  const query = {
    [traceIDQueryParameter]: traceID,
    [btTagVersionQueryParameter]: window.__bt_tag_d?.version || "",
    [sessionIDQueryParameter]: sessionID,
    upapi: String(true),
  };

  const metadata = {
    ...extraMeta,
    ...meta,
  };

  const body = {
    event,
    meta: metadata,
    orgID,
    severity: params.severity,
    websiteID: websiteID,
  };

  const search = new URLSearchParams(query);
  const url = new URL(`https://${apiDomain}/log?` + search);

  return fetch(url, {
    method: "POST",
    body: JSON.stringify(body),
    keepalive: true,
  }).catch(() => null); // avoid error on log affect script execution
}

/*
  These methods are used to log only a certain percentage of logs
  Usually only 1% by default to avoid overwhelmind our storage
  Copied from up-browser repo commonUtils
 */

// Returns a random integer between zero on the `max` value (for example: if max=100, the range is [0-99])
export function getRandomInt(max: number) {
  return Math.floor(Math.random() * Math.floor(max));
}

// Returns true a given percentage (0-100) of the time
// 1% by default
export function shouldLogByProbability(percentage: number = 1) {
  return getRandomInt(100) < percentage;
}
